// extracted by css-extract-rspack-plugin
export default {"root":"root-dIjz9a","add-company-link-buttons-container":"add-company-link-buttons-container-TpKY8x","addCompanyLinkButtonsContainer":"add-company-link-buttons-container-TpKY8x"};